import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancelAssessmentComponent } from './cancel-assessment.component';
import { ExternalNotesModule } from '../../external-notes/external-notes.module';
import { FormsModule } from '@angular/forms';
import { AiAssistantModule } from '../../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [CancelAssessmentComponent],
  imports: [
    CommonModule,
    FormsModule,
    ExternalNotesModule,
    AiAssistantModule
  ],
  exports: [CancelAssessmentComponent],
  entryComponents: [CancelAssessmentComponent]
})
export class CancelAssessmentModule { }
